import { Grid } from "antd";
import { useTranslation } from "react-i18next";
import { CoachList, Title } from "../../../../components";
import { ContentWrapper } from "../../../../layouts/components";
import { useCoachesContext } from "../../context/CoachesContext";
import ResortFilter from "../ResortFilter";
import styles from "./styleModule";

const CoachesContainer = () => {
  const { filterCoachList } = useCoachesContext();
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <ContentWrapper>
      <div className={styles.coachesContainer}>
        <div
          className={`${styles.titleContainer} ${
            screens.sm ? "" : styles.mobile
          }`}
        >
          <Title
            title={t("coach.title")}
            subtitle={t("coach.subtitle")}
            needHome={true}
          />
        </div>
        <ResortFilter />
        <CoachList coachList={filterCoachList} />
      </div>
    </ContentWrapper>
  );
};

export default CoachesContainer;
